import { Component, inject } from '@angular/core';
import { ViewportEnterDirective } from "../viewport-enter-directive";
import { ActiveRoute } from '../active-route';

@Component({
  selector: 'app-contact',
  imports: [ViewportEnterDirective],
  standalone: true,
  templateUrl: './contact.html',
  styleUrl: './contact.scss',
})
export class Contact {
  activeRoute= inject(ActiveRoute);
}
